/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './search-pagination.stache';
import can from 'can';
import appContext from 'scripts/app-context';

const limit = 10,
      maxPagesPerView = 5;

Component.extend({
    tag: 'search-pagination',
    template: template,
    viewModel: {
        define: {
            nextPage: {
                Type: can.Map,
                Value: can.Map
            },
            previousPage: {
                Type: can.Map,
                Value: can.Map
            },
            getPages: {
                get() {
                    let paginationSettings = this.attr('paginationSettings');

                    let startIndex = parseInt(paginationSettings.attr('startIndex')),
                        queries = paginationSettings.attr('queries') || null,
                        total = parseInt(paginationSettings.attr('total')),
                        pages = [];
                    
                    if(!startIndex || !total){
                        return;
                    } 

                    if(queries && queries.attr('nextPage')){
                        this.attr('nextPage', queries.attr('nextPage').attr(0));
                    } else {
                        this.attr('nextPage', null);
                    }

                    if(queries && queries.attr('previousPage')){
                        this.attr('previousPage', queries.attr('previousPage').attr(0));
                    } else {
                        this.attr('previousPage', null);
                    }

                    
                    let totalPages = Math.ceil(total/limit),
                        pagesNumber = Math.floor(startIndex/maxPagesPerView),
                        lowerPageBoundary = (startIndex == 1) ? 1 : (pagesNumber*maxPagesPerView)/10;

                    for(let i = lowerPageBoundary, 
                            max = (lowerPageBoundary + maxPagesPerView); i < max && i <= totalPages; i++) {

                        let pageIndex = (i == 1) ? i : Math.round((i - 1) * limit) + 1;

                        pages.push({
                            value: i, 
                            startIndex: pageIndex, 
                            isActive: pageIndex == startIndex
                        });
                    }
                    
                    return pages;
                }
            }
        },
        changeStartIndex: function(event, startIndex) {
            event.preventDefault();
            if($(event.target).hasClass('s-page--active')){
                return;
            }
            appContext.model.dispatch('page-changed', [startIndex]);
        }
    }
});
